/**
 * 课程查看
 * @Author:wuTao
 * @Date 2020/11/12
 */
import React from 'react';
import {connect} from 'dva';

import {component_tool, framework_tool, utils_tool} from '@/tool';
import {modelUtils} from '@/utils';
import {programDetailColumns} from './columns'
import moment from "moment";
import {string} from "prop-types";
import { WizAuthority } from "@/containers/common";

let {WizContainer} = framework_tool

let {Session, $$, checkStrLength} = utils_tool;
let {
  WizRow, WizCol, WizTable, WizCard, WizSpin, WizTabs, WizTag, WizMenu, WizButton,WizTooltip
} = component_tool;
const {SubMenu} = WizMenu;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}

const getProgramDetailRecord = (history) => {
  let record;
  if (history.location && history.location.record) {
    record = history.location.record;
    Session.set('programDetailRecord', arrangeRecord(record));
  } else {
    record = Session.get('programDetailRecord') ? Session.get('programDetailRecord') : {};
  }
  return record
}
/**行数据处理 */
const arrangeRecord = (record) => {
  let data = record;
  if (data.imgOne == -1) {
    data.imgOne = null;
  }
  data.date = {
    startDate: record.startDate,
    endDate: record.endDate
  }
  data.limit = {
    limitOrder: record.limitOrder,
    preCondition: record.preConditionId && record.preCondition ? record.preCondition : undefined,
    preConditionId: record.preConditionId
  }
  if (record.shareWays) {
    let ways = record.shareWays.split(",");
    for (let i = 0; i < ways.length; i++) {
      if (ways[i] == '0') {
        data.shareWay_wechat = [1]
      } else if (ways[i] == '1') {
        data.shareWay_community = [1]
      }
    }
  }
  //拼接分类
  if (record.programCategoryNames && record.programCategoryIds) {
    let programCategory = [];
    let programCategoryNames = record.programCategoryNames instanceof string && record.programCategoryNames ? record.programCategoryNames : '';
    let programCategoryIds = record.programCategoryIds instanceof string && record.programCategoryIds ? record.programCategoryIds : '';
    let cNames = programCategoryNames.split(",");
    let cIds = programCategoryIds.split(",");
    if (cNames.length === cIds.length) {
      for (let i = 0; i < cNames.length; i++) {
        programCategory.push({title: cNames[i], key: cIds[i]})
      }
      data.programCategory = programCategory;
      data.programCategoryIds = cIds;
    }
  }
  //讲师
  if (data.lectureIds) {
    let lectures = data.lectureIds.split(",");
    data.lectures = lectures;
  }
  //范围权限拼接
  let target = ''
  if (record.authData && Object.keys(record.authData)) {
    let authData = record.authData;
    if (authData['orgIds'] && authData['orgIds'].length) {
      target += ' 组织范围：'
      authData['orgIds'].forEach(org => {
        target += org['name'] + ','
      });
      if (target.substr(target.length - 1) === ',') {
        target = target.substr(0, target.length - 1);
      }
      target += ' '
    }
    if (authData['positionIds'] && authData['positionIds'].length) {
      target += ' 岗位：'
      authData['positionIds'].forEach(org => {
        target += org['name'] + ','
      });
      if (target.substr(target.length - 1) === ',') {
        target = target.substr(0, target.length - 1);
      }
      target += ' '
    }
    if (authData['positionCategoryIds'] && authData['positionCategoryIds'].length) {
      target += ' 岗位分类：'
      authData['positionCategoryIds'].forEach(org => {
        target += org['name'] + ','
      });
      if (target.substr(target.length - 1) === ',') {
        target = target.substr(0, target.length - 1);
      }
      target += ' '
    }
    if (authData['personIds'] && authData['personIds'].length) {
      target += ' 指定人员：'
      authData['personIds'].forEach(org => {
        target += org['userName'] + '(' + org['fullName'] + '),'
      });
      if (target.substr(target.length - 1) === ',') {
        target = target.substr(0, target.length - 1);
      }
      target += ' '
    }
  }
  data.authStr = target;
  return data;
}

class ProgramDetailShow extends WizContainer {

  componentName = 'programDetailShow';

  constructor(props) {
    super(props);
    let initialValue = getProgramDetailRecord(props.history);
    this.state = {
      programId: initialValue && initialValue.id,
      programContent: [],
      examCount: 0,
      scheduleCount: 0,
      scheduleMinute: 0,
      showMore: false,
    };
    this.initialValue = initialValue;
  }

  _componentWillMount() {
    if (this.state.programId) {
      this.getProgramInfo();
      this.getProgramContent();
    }
    if (this.initialValue && this.initialValue.lectureIds) {
      this.getPersonInfoByPersonIdList()
    }
  }

  /**获取课程信息 */
  getProgramInfo() {
    this.doAction({
      path: 'program/getProgramById',
      payload: {
        key: 'getProgramById',
        apiParams: {
          id: this.state.programId,
        }
      }
    });
  }

  /**获取课程内容 */
  getProgramContent() {
    this.doAction({
      path: 'programEntity/getListByProgramId',
      payload: {
        key: 'getProgramEntityList',
        apiParams: {
          programId: this.state.programId,
        }
      }
    });
  }

  /**获取对应的讲师数据，讲师选择组件需要显示默认值 */
  getPersonInfoByPersonIdList() {
    this.doAction({
      path: 'personManage/getPersonInfoByPersonIdList',
      payload: {
        key: 'getPersonInfoByPersonIdList',
        apiParams: {
          personIdList: this.initialValue.lectures,
        }
      }
    });
  }

  propsAndStateOnChange = {
    getProgramEntityList: this._getContentOver.bind(this),
    personInfo: this._getPersonInfoOver.bind(this),
    getProgramInfo: this._getProgramInfoOver.bind(this)
  };

  _getProgramInfoOver(nextProps, nextState) {
    if (nextProps.getProgramInfo.code === 1) {
      this.initialValue = nextProps.getProgramInfo.data;
    } else {
      wizNotice.error(nextProps.getProgramInfo.msg);
    }
    return true
  }

  _getContentOver(nextProps, nextState) {
    if (nextProps.getProgramEntityList.code == 1) {
      nextState.programContent = nextProps.getProgramEntityList.data;
      if (nextProps.getProgramEntityList.data && nextProps.getProgramEntityList.data instanceof Array) {
        let scheduleCount = 0;
        let scheduleMinute = 0;
        let examCount = 0;
        nextProps.getProgramEntityList.data.forEach(data => {
          if (data.type == 1) {
            examCount++;
          } else if (data.type == 0) {
            scheduleCount++;
            scheduleMinute += data.duration && parseInt(data.duration) >= 0 ? parseInt(data.duration) : 0;
          }
        })
        nextState.scheduleCount = scheduleCount;
        nextState.scheduleMinute = scheduleMinute;
        nextState.examCount = examCount;
      }

    }
    return true;
  }

  _getPersonInfoOver(nextProps, nextState) {
    let personInfo = nextProps.personInfo.data;
    if (nextProps.personInfo.code == 1 && personInfo && personInfo.length) {
      let lecturesName = '';
      if (personInfo && personInfo instanceof Array && personInfo.length > 0) {
        personInfo.forEach(person => lecturesName = lecturesName === '' ? person.fullName : lecturesName + ',' + person.fullName)
      }
      this.initialValue.lecturesName = lecturesName;
      this.initialValue.personInfo = personInfo;
    }
    return true;
  }


  /**概要内容 */
  outlineView(count, title, countColor) {
    return (
      <span className="outline-view">
        <div className="outline-count" style={countColor}>{count}</div>
        <div className="outline-title">{title}</div>
      </span>
    )
  }

  _renderItemRow(title1, val1, title2, val2) {
    let initialValue = this.initialValue;
    if (!title2) {
      return (
        <WizRow className='administrationScope-row-item'>
          <WizCol className='col-item' span={3} offset={1}>{title1 + '：'}</WizCol>
          {
            title1 === '课程受众' ? (
              <>
                <WizCol span={1}>
                  {/* <span>{!val1 || val1==='' || val1.length<=30 ? val1 :(!this.state.showMore ? val1.substr(0, 30) : val1)}</span> */}
                  {/* {!val1 || val1==='' || val1.length<=30 ? '':(this.state.showMore ? (
                    <span style={{marginLeft: 10}}>
                    <WizButton type="link" size={'small'} onClick={() => this.setState({
                      showMore: false
                    })}>{'收起>'}</WizButton>
                    </span>
                  ) : (
                    <span style={{marginLeft: 10}}>
                     <WizButton type="link" size={'small'} onClick={() => this.setState({
                       showMore: true
                     })}>{'查看更多>'}</WizButton>
                    </span>
                  ))} */}
                  <WizAuthority value={val1} mode='Button' />
                </WizCol>
                <WizCol span={4} style={{marginLeft:10,}}>
                  <WizTag color="cyan">
                    <WizTooltip
                      title={'应学习总人数：'+(initialValue && initialValue.targetScoreInfo && initialValue.targetScoreInfo.scopeCount ? initialValue.targetScoreInfo.scopeCount : 0)}
                      placement="topLeft"
                    >
                      {initialValue && initialValue.targetScoreInfo && initialValue.targetScoreInfo.scopeCount ? initialValue.targetScoreInfo.scopeCount : 0 }
                    </WizTooltip>
                  </WizTag>
                  <WizTag color="orange">
                    <WizTooltip
                      title={'已学习人数：'+(initialValue && initialValue.targetScoreInfo && initialValue.targetScoreInfo.successCount ? initialValue.targetScoreInfo.successCount : 0)}
                      placement="topLeft"
                    >
                      {initialValue && initialValue.targetScoreInfo && initialValue.targetScoreInfo.successCount ? initialValue.targetScoreInfo.successCount : 0 }
                    </WizTooltip>
                  </WizTag>
                </WizCol>
              </>
            ) : (
              <WizCol span={16}>{val1 && val1}</WizCol>
            )
          }
        </WizRow>
      )
    } else {
      return (
        <WizRow className='administrationScope-row-item'>
          <WizCol className='col-item' span={3} offset={1}>{title1 + '：'}</WizCol>
          <WizCol span={8}>{val1 && val1}</WizCol>
          <WizCol className='col-item' span={3} offset={1}>{title2 + '：'}</WizCol>
          <WizCol span={8}>{val2 && val2}</WizCol>
        </WizRow>
      )
    }
  }

  _render() {
    const {programEntityLoading, personManageLoading} = this.props;
    let initialValue = this.initialValue;
    let other = {};
    let columns = programDetailColumns(this, initialValue && initialValue.detailedList ? initialValue.detailedList : [], other);
    let dateDay = '';
    if (initialValue && initialValue.startDate) {
      dateDay = formatterDate(initialValue.startDate);
    }
    if (dateDay != '' && initialValue && initialValue.endDate) {
      dateDay = dateDay + ' ~ ' + formatterDate(initialValue.endDate);
    } else if (initialValue && initialValue.endDate) {
      dateDay = formatterDate(initialValue.endDate);
    }
    return (
      <>
        <WizSpin tip={'加载中'} spinning={programEntityLoading || personManageLoading}>
          <WizCard title={'课程信息'}>
            {this._renderItemRow('名称', initialValue && initialValue.name, '课程编码', initialValue && initialValue.scoId)}
            {this._renderItemRow('状态', !initialValue || !initialValue.status || initialValue.status === 0 ? '草稿' : initialValue.status === 1 ? '已发布'
              : '已关闭', '课程时间', dateDay)}
            {this._renderItemRow('课程分类', initialValue && initialValue.programCategoryNames, '讲师', initialValue.personInfo && initialValue.personInfo[0] && initialValue.personInfo[0].fullName)}
            {this._renderItemRow('课程受众', initialValue && initialValue.authData, null, null)}
          </WizCard>
          <WizCard>
            <WizTabs animated={false}>
              <WizTabs.TabPane tab="课程内容" key={'program_content'}>
                <div>
                  <div className="table-row">
                    <WizTable pagination={false} columns={columns} dataSource={this.state.programContent}/>
                  </div>
                  <div className="table-row">
                    <div className="outline-font">课程概要</div>
                  </div>
                  <div className="div-outline">
                    {this.outlineView(this.state.scheduleCount, '总课件数', {color: '#3D80E3'})}
                    <span className="separator"/>
                    {this.outlineView(this.state.scheduleMinute, '总时长(分)', {color: '#3DE3D5'})}
                    <span className="separator"/>
                    {this.outlineView(this.state.examCount, '总考试数', {color: '#E3773D'})}
                  </div>
                </div>
              </WizTabs.TabPane>
            </WizTabs>
          </WizCard>
        </WizSpin>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {programEntity, personManage, program} = state;
  const getProgramEntityList = modelUtils.getModelEntity(programEntity, "getProgramEntityList");
  const getProgramInfo = modelUtils.getModelEntity(program, "getProgramById");
  const personInfo = modelUtils.getModelEntity(personManage, "getPersonInfoByPersonIdList");
  const load = modelUtils.getLoadingState(state, ['programEntity', 'personManage']);
  return {
    getProgramEntityList: getProgramEntityList,
    personInfo: personInfo,
    getProgramInfo,
    ...load
  }
};

export default connect(mapStateToProps)(ProgramDetailShow);
